import { useGlobalModal } from "@/core/context/GlobalModalProvider"
import { DiscoModal } from "@disco-ui"
import { TestIDProps } from "@utils/typeUtils"
import RenameMediaAssetForm from "./RenameMediaAssetForm"

type Props = TestIDProps

function RenameAssetModal({ testid = "RenameAssetModal" }: Props) {
  const modal = useGlobalModal("renameAsset")
  const { uploadedAssetId } = modal.params

  return (
    <DiscoModal
      isOpen={modal.isOpen}
      onClose={modal.close}
      modalContentLabel={"Rename Asset Modal"}
      testid={testid}
      title={"Edit Asset"}
      minHeight={"unset"}
      body={
        <RenameMediaAssetForm
          uploadedAssetId={uploadedAssetId ?? ""}
          onClose={modal.close}
        />
      }
      buttons
      nested
    />
  )
}

export default RenameAssetModal
